export default {
    brandAccent: '#f6bbb8'
}